
































































import {
  CLASSIFIED_FORM_NS,
  FormState
} from '~/store/modules/shared/classifieds/form/state'
import { computed, defineComponent, ref, toRefs } from '@nuxtjs/composition-api'
import { useClassifiedForm } from '~/compositions/form'
import { formFieldProps } from '~/constants/form'
import { useNamespacedStore } from '~/compositions/store'
import { FieldChange } from '~/models/form/types'
import CFormError from '~/components/shared/configurable/form/CFormError.vue'
import { Ref } from '@vue/composition-api'
import { useUserAgent } from '~/compositions/user-agent'
import CImg from '~/components/shared/configurable/image/CImg.vue'
export default defineComponent({
  components: {
    CImg,
    CFormError
  },
  props: formFieldProps,
  setup(props) {
    const { specs, name } = toRefs(props)

    const selectedColor = ref<number | null>(null)

    function onValue(v: Ref) {
      if (Array.isArray(v.value)) {
        selectedColor.value = v.value.length ? v.value[0] : null
      } else {
        selectedColor.value = v.value || null
      }
    }

    const { inEditMode, valuesChanged, error } = useClassifiedForm(props, {
      onValue
    })

    const { state } = useNamespacedStore<FormState>(CLASSIFIED_FORM_NS)

    const schemaExtras = computed(() => state.extras)

    const handleColorChange = (colorId: number) => {
      selectedColor.value = colorId
      emitChanges()
    }

    const colorsAsOptions = computed(() =>
      specs.value.values.map(c => {
        return { text: c.name, value: c.value }
      })
    )
    const emitChanges = () => {
      const colorRelatedChanges: FieldChange[] = [
        {
          name: name.value,
          value: selectedColor.value
        }
      ]

      valuesChanged(colorRelatedChanges)
    }

    const { isMobile } = useUserAgent()

    return {
      selectedColor,
      handleColorChange,
      error,
      schemaExtras,
      inEditMode,
      colorsAsOptions,
      isMobile
    }
  }
})
